import { render, staticRenderFns } from "./form-cadastro.vue?vue&type=template&id=cd3da1f4"
import script from "./form-cadastro.vue?vue&type=script&lang=js"
export * from "./form-cadastro.vue?vue&type=script&lang=js"
import style0 from "./form-cadastro.vue?vue&type=style&index=0&id=cd3da1f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports